import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as interFace from "../../Config/interface.config";
import * as PATH from "../../API/path";
import APIRequest from "../../API";

const initialState: Partial<interFace.UserDetails> = {
  loading: false,
};

// Get user details by username for viewing a profile
export const getUserDetailsByUsername = createAsyncThunk(
  "/user/username/details",
  async (username: string, { rejectWithValue }) => {
    try {
      const path = { ...PATH.get_user_by_username };
      path.url = path.url.replace("{{username}}", username);
      const { data }: any = await APIRequest(path);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const viewedProfileSlice = createSlice({
  name: "viewedProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserDetailsByUsername.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      getUserDetailsByUsername.fulfilled,
      (state, { payload }) => {
        Object.assign(state, payload);
        state.loading = false;
      }
    );

    builder.addCase(getUserDetailsByUsername.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default viewedProfileSlice.reducer;
